export default "__VITE_PUBLIC_ASSET__1a278d8e__"